import { Type } from "class-transformer";
import { ValidateImageUpload } from "@/util/ValidationUtil";
import { SlowInspectionReqDto } from "@/dto/inspection/slow/SlowInspectionReqDto.ts";
import { Id } from "@/dto/CommonDto.ts";
import User from "@/model/User.ts";
import { InspectionSlowStationDto } from "@/dto/inspection/slow/InspectionSlowStationDto.ts";
import { ValidateNested } from "class-validator";
import { InspectionOtherCpoDto } from "@/dto/inspection/InspectionOtherCpoDto.ts";

export class SlowInspectionDto extends Id {
    @ValidateNested()
    @Type(() => SlowInspectionReqDto)
    req: SlowInspectionReqDto;

    /**
     * 충전소 및 주위 전경
     */
    @Type(() => Object)
    @ValidateImageUpload("충전소 및 주위 전경")
    OVERVIEW: File;

    /**
     * 분전반 외부
     */
    @Type(() => Object)
    @ValidateImageUpload("분전반 외부")
    PANELEXT: File;

    /**
     * 분전반 내부
     */
    @Type(() => Object)
    @ValidateImageUpload("분전반 내부")
    PANELINT: File;

    /**
     * 충전기 안내판
     */
    @Type(() => Object)
    @ValidateImageUpload("충전기 안내판")
    GUIDESIGN: File;

    /**
     * 전용 주차구역
     */
    @Type(() => Object)
    @ValidateImageUpload("전용 주차구역")
    PARKING: File;

    /**
     * 볼라드 정상 설치 여부
     */
    @Type(() => Object)
    @ValidateImageUpload("볼라드 정상 설치 여부")
    BOLLARD: File;

    /**
     * 연결통로 정상 여부
     */
    @Type(() => Object)
    @ValidateImageUpload("연결통로 정상 여부")
    BOLT: File;

    /**
     * 계량기
     */
    @Type(() => Object)
    @ValidateImageUpload("계량기")
    METER: File;

    /**
     * 충전기 명판
     */
    @Type(() => Object)
    @ValidateImageUpload("충전기 명판")
    NAMEPLATE: File;

    /**
     * Site 1
     */
    @Type(() => Object)
    @ValidateImageUpload("Site 1", false)
    SITE1: File;

    /**
     * Site 2
     */
    @Type(() => Object)
    @ValidateImageUpload("Site 2", false)
    SITE2: File;

    /**
     * Site 3
     */
    @Type(() => Object)
    @ValidateImageUpload("Site 3", false)
    SITE3: File;

    /**
     * Site 4
     */
    @Type(() => Object)
    @ValidateImageUpload("Site 4", false)
    SITE4: File;

    constructor(user: User, data?: SlowInspectionReqDto) {
        super();
        if (data) {
            this.req = data;
        } else {
            this.req = {
                inspectionSlowStationDto: new InspectionSlowStationDto(),
                inspectionSlowChargerList: [],
                inspectionImageList: [],
                inspectionOtherCpoList: [new InspectionOtherCpoDto()],
                inspectionOutline: {
                    inspectorId: user?.email,
                    inspectorName: user?.name,
                    stationId: null,
                    businessName: null,
                    inspectorCompany: null,
                    inspectorCellphoneNumber: user?.phone,
                    inspectDate: null,
                    temperature: null,
                    humidity: null,
                    siteManagerName: null,
                    siteManagerPhoneNumber: null,
                    siteEvCount: null,
                    isNotCorrect: null,
                    notCorrectDetail: null,
                    isCompleted: false,
                },
            };
        }
    }
}